import React, {Fragment} from "react";
import UserSessionService from "../services/UserSessionService";
import ToastHelper from "../utils/ToastHelper";
import FileUtil from "../domain/Util/FileUtil";
import {Col} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";
import DropdownComponent from "./DropdownComponent";
import S3DocumentUploadComponent from "./S3DocumentUploadComponent";
import UtilityLimitIncreaseTypeService from "../services/UtilityLimitIncreaseTypeService";
import LimitIncreaseConfig from "../domain/Util/LimitIncreaseConfig";
import LimitIncreaseDocumentType from "../enum/LimitIncreaseDocumentType";
import LimitIncreaseRequest from "../domain/LimitIncreaseRequest";
import RegistrationLimitIncreaseService from "../services/RegistrationLimitIncreaseService";
import LoadingSpinnerComponent from "./LoadingSpinnerComponent";
import ViewHeaderComponent from "./ViewHeaderComponent";
import CreateObjectRowWithLabelComponent from "./CreateObjectRowWithLabelComponent";
import {Spinner} from "react-bootstrap";

const SOURCE_OF_INCOME = "SOURCE_OF_INCOME";
const PROOF_OF_INCOME = "PROOF_OF_INCOME";
const PROOF_OF_RESIDENCY = "PROOF_OF_RESIDENCY";
const SUMMARY = "SUMMARY";

const STEPS = {
    0: SOURCE_OF_INCOME,
    1: PROOF_OF_INCOME,
    2: PROOF_OF_RESIDENCY,
    3: SUMMARY,
}

export default class CustomerLimitIncreaseRequestComponent extends React.Component {
    constructor(props) {
        super(props);

        this.viewRef = null;
        this.registeringPartnerId = UserSessionService.getUser().registeringPartnerId;
        this.registeringChannelId = UserSessionService.getUser().registeringChannelId;

        this.requiresProofOfAddress = true;
        this.requiresSourceOfIncome = true;

        this.state = {

            proofOfAddressTypes: [],
            proofOfIncomeTypes: [],
            sourceOfIncomeTypes: [],

            currentStep: SOURCE_OF_INCOME,
            currentStepIndex: 0,

            canProceedFromProofOfIncome: false,
            canProceedFromProofOfResidency: false,

            submitting: false,
            loading: true,
            addressDocuments: [],

            incomeValuesValid: false,
            incomeDocuments: []

        };

        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.processSubmit = this.processSubmit.bind(this);
        this.onDocumentUploaded = this.onDocumentUploaded.bind(this);
        this.checkFinishedUploading = this.checkFinishedUploading.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let serviceCalls = [];

        let INDEX_PROOF_OF_ADDRESS = -1;
        let INDEX_SOURCE_OF_INCOME = -1;
        let INDEX_PROOF_OF_INCOME = -1;

        if (this.requiresProofOfAddress) {
            INDEX_PROOF_OF_ADDRESS = serviceCalls.length;
            serviceCalls.push(UtilityLimitIncreaseTypeService.retrieveProofOfAddressTypes());
        }
        if (this.requiresSourceOfIncome) {
            INDEX_SOURCE_OF_INCOME = serviceCalls.length;
            serviceCalls.push(UtilityLimitIncreaseTypeService.retrieveSourceOfIncomeTypes());
            INDEX_PROOF_OF_INCOME = serviceCalls.length;
            serviceCalls.push(UtilityLimitIncreaseTypeService.retrieveProofOfIncomeTypes());
        }

        Promise.all(serviceCalls).then(responseArray => {
            let newState = {
                loading: false
            };
            if (this.requiresProofOfAddress) {
                let proofOfAddressResponse = responseArray[INDEX_PROOF_OF_ADDRESS];
                if (Array.isArray(proofOfAddressResponse)) {
                    newState.proofOfAddressTypes = proofOfAddressResponse;
                } else {
                    ToastHelper.formatError(proofOfAddressResponse);
                }
            }
            if (this.requiresSourceOfIncome) {
                let sourceOfIncomeResponse = responseArray[INDEX_SOURCE_OF_INCOME];
                let proofOfIncomeResponse = responseArray[INDEX_PROOF_OF_INCOME];
                if (Array.isArray(sourceOfIncomeResponse)) {
                    newState.sourceOfIncomeTypes = sourceOfIncomeResponse;
                } else {
                    ToastHelper.formatError(sourceOfIncomeResponse);
                }
                if (Array.isArray(proofOfIncomeResponse)) {
                    newState.proofOfIncomeTypes = proofOfIncomeResponse;
                } else {
                    ToastHelper.formatError(proofOfIncomeResponse);
                }
            }

            this.setState(newState);
        });
    }

    isValid() {
        if (this.requiresProofOfAddress) {
            if (this.state.addressDocuments.length < LimitIncreaseConfig.MIN_ADDRESS_DOCUMENTS)
                return false;
            for (let i = 0; i < this.state.addressDocuments.length; i++) {
                let singleDocument = this.state.addressDocuments[i];
                if (!CustomerLimitIncreaseRequestComponent.isValidDocument(singleDocument))
                    return false;
            }
        }
        if (this.requiresSourceOfIncome) {
            if (this.state.incomeValuesValid === false) return false;
            if (this.state.incomeDocuments.length < LimitIncreaseConfig.MIN_INCOME_DOCUMENTS)
                return false;

            for (let i = 0; i < this.state.incomeDocuments.length; i++) {
                let singleDocument = this.state.incomeDocuments[i];
                if (!CustomerLimitIncreaseRequestComponent.isValidDocument(singleDocument))
                    return false;
            }
        }
        return true;
    }

    static isValidDocument(doc) {
        return doc.documentType !== undefined && doc.file !== undefined;
    }

    onSubmitClick() {

        let sourceOfIncomeValue = this.requiresSourceOfIncome ? this.state.incomeValue : {};
        this.setState({
            submitting: true
        }, () => {
            this.processSubmit(sourceOfIncomeValue);
        })
    }

    processSubmit(sourceOfIncomeValues) {
        this.submitRequirements = {
            addressDocuments: [],
            sourcesOfIncome: [],
            documentsToUpload: {}
        };

        // add address documents
        if (this.requiresProofOfAddress) {
            this.state.addressDocuments.forEach((addressDocument, index) => {
                let documentUploadKey = "addressDocument-" + index;
                this.submitRequirements.documentsToUpload[documentUploadKey] = {
                    file: addressDocument.file,
                    documentType: LimitIncreaseDocumentType.PROOF_OF_ADDRESS,
                    addressDocumentType: addressDocument.documentType,
                    uploaded: false
                };

            });
        }

        // add income documents
        if (this.requiresSourceOfIncome) {
            this.submitRequirements.sourcesOfIncome.push({
                source: sourceOfIncomeValues.name,
                value: "0.00",
                incomeDocuments: []
            });

            this.state.incomeDocuments.forEach((incomeDocument, index) => {
                let documentUploadKey = "incomeDocument-" + index;
                this.submitRequirements.documentsToUpload[documentUploadKey] = {
                    file: incomeDocument.file,
                    documentType: LimitIncreaseDocumentType.PROOF_OF_INCOME,
                    incomeDocumentType: incomeDocument.documentType,
                    uploaded: false
                };
            });
        }

        // upload the documents
        let documentUploadKeys = Object.keys(this.submitRequirements.documentsToUpload);
        if (documentUploadKeys.length > 0) {
            documentUploadKeys.forEach(documentUploadKey => {
                let documentToUpload = this.submitRequirements.documentsToUpload[documentUploadKey];
                this.uploadDocument(documentUploadKey, documentToUpload, this.onDocumentUploaded);
            });
        } else {
            this.checkFinishedUploading();
        }

    }

    onDocumentUploaded(documentUploadKey, uploadedDocument, uploadResponse) {
        if (uploadResponse.id) {
            this.submitRequirements.documentsToUpload[documentUploadKey].uploaded = true;
            if (uploadedDocument.documentType === LimitIncreaseDocumentType.PROOF_OF_ADDRESS) {
                this.submitRequirements.addressDocuments.push({
                    documentType: uploadedDocument.addressDocumentType,
                    metaDataId: uploadResponse.id
                });
            } else {
                this.submitRequirements.sourcesOfIncome[0].incomeDocuments.push({
                    documentType: uploadedDocument.incomeDocumentType,
                    metaDataId: uploadResponse.id
                });
            }
            this.checkFinishedUploading();
        }
    }

    checkFinishedUploading() {

        let documentKeys = Object.keys(this.submitRequirements.documentsToUpload);
        for (let i = 0; i < documentKeys.length; i++) {
            if (this.submitRequirements.documentsToUpload[documentKeys[i]].uploaded === false) {
                return;
            }
        }

        let data = LimitIncreaseRequest.createRequest(
            this.props.registrationId,
            this.submitRequirements.addressDocuments,
            this.submitRequirements.sourcesOfIncome
        );

        RegistrationLimitIncreaseService.requestLimitIncrease(data).then(response => {
            if (response.id) {
                ToastHelper.success("Submitted Limit Increase request.");
                if (this.props.btnBackClick)
                    this.props.btnBackClick();
            } else {
                this.setState({
                    submitting: false
                })
                ToastHelper.formatError(response);
            }
        });

    }

    uploadDocument(key, uploadRequest, callback) {

        let file = uploadRequest.file;
        let documentType = uploadRequest.documentType;

        let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
        let mimeType = FileUtil.getMimeType(fileType);

        let documentUploadRequest = {"file-type": fileType, "document-type": documentType};
        RegistrationLimitIncreaseService.retrievePresignedUrl(documentUploadRequest).then(response => {
            if (response.presignedUrl === undefined) {
                ToastHelper.formatError(response);
                return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', response.presignedUrl);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        callback(key, uploadRequest, response);
                    } else {
                        ToastHelper.error("Error while uploading document.");
                    }
                }
            };
            xhr.overrideMimeType(mimeType);
            xhr.setRequestHeader('Content-Type', mimeType);
            xhr.send(file.fileUpload);
        });
    }

    nextStep(currentStep, currentStepIndex) {
        let nextStepIndex = currentStepIndex + 1;
        let nextStep = STEPS[nextStepIndex];

        this.setState({
            currentStep: nextStep,
            currentStepIndex: nextStepIndex
        })
    }

    backStep(currentStep, currentStepIndex) {
        if (currentStepIndex !== 0) {
            let nextStepIndex = currentStepIndex - 1;
            let nextStep = STEPS[nextStepIndex];

            this.setState({
                currentStep: nextStep,
                currentStepIndex: nextStepIndex
            })
        }
    }

    render() {
        if (this.state.loading)
            return <LoadingSpinnerComponent/>;
        else
            switch (this.state.currentStep) {
                case SOURCE_OF_INCOME:
                    return this.renderSourceOfIncome()
                case PROOF_OF_INCOME:
                    return this.renderProofOfIncome()
                case PROOF_OF_RESIDENCY:
                    return this.renderProofOfResidency()
                case SUMMARY:
                    return this.renderSummary()
                default :
                    return <Fragment>Unknown Step</Fragment>
            }
    }

    //STEP 1
    renderSourceOfIncome() {
        return <Fragment>
            <ViewHeaderComponent>Source of Income</ViewHeaderComponent>
            <DropdownComponent
                ref={(ref) => this.viewRef = ref}
                value={this.state.incomeValue ? this.state.incomeValue.name : undefined}
                options={this.state.sourceOfIncomeTypes}
                optionValue={"name"}
                optionText={"displayValue"}
                disableSearch={true}
                onChange={(value) => {
                    this.setState({
                        incomeValue: value
                    })
                }
                }
            />
            <hr/>
            {this.renderModalFooterBackButton()}
            {'   '}
            {this.state.incomeValue && <Fragment>
                {this.renderModalFooterNextButton()}
            </Fragment>}
        </Fragment>
    }

    //STEP 2
    renderProofOfIncome() {
        return <Fragment>
            <ViewHeaderComponent>Proof of Income</ViewHeaderComponent>
            {
                this.state.incomeDocuments.length === 0 && <Fragment>

                    <Fragment>No income documents added</Fragment>
                    <br/>
                    <br/>

                </Fragment>
            }

            {
                this.state.incomeDocuments.map((singleIncomeDocument, index) => {
                    return this.renderSingleIncomeDocument(index);
                })
            }

            {this.state.incomeDocuments.length < LimitIncreaseConfig.MAX_INCOME_DOCUMENTS && this.renderIncomeDocumentAddSection()}

            <hr/>
            {this.renderModalFooterBackButton()}
            {'   '}
            {this.state.canProceedFromProofOfIncome &&
            <Fragment>
                {this.renderModalFooterNextButton()}
            </Fragment>
            }
        </Fragment>
    }

    renderIncomeDocumentAddSection() {
        return this.renderAddButton(
            () => {
                let incomeDocuments = [...this.state.incomeDocuments];
                incomeDocuments.push({});
                this.setState({
                    incomeDocuments: incomeDocuments
                })
            }, "Proof Of Income");
    }

    renderSingleIncomeDocument(documentIndex) {
        let documentObject = this.state.incomeDocuments[documentIndex];
        let documentType = documentObject.documentType;
        return <Fragment key={documentIndex}>
            <Fragment>
                <Col md={12} style={{display: "flex", padding: "0px"}}>
                    <div style={{flex: "1"}}>
                        <DropdownComponent
                            options={this.state.proofOfIncomeTypes}
                            optionValue={"name"}
                            optionText={"displayValue"}
                            placeholder={"Document Type"}
                            disableSearch={true}
                            onChange={(selectedOption) => {

                                let incomeDocuments = [...this.state.incomeDocuments];
                                if (selectedOption === null)
                                    incomeDocuments[documentIndex].documentType = null;
                                else
                                    incomeDocuments[documentIndex].documentType = selectedOption.name;

                                this.setState({incomeDocuments: incomeDocuments})
                            }}
                            value={documentObject.documentType}
                        />
                    </div>
                    {
                        this.renderImageCloseButton(() => {
                            let canProceedFromProofOfIncome = true;
                            let incomeDocuments = [...this.state.incomeDocuments];
                            incomeDocuments.splice(documentIndex, 1);
                            if (incomeDocuments.length === 0) {
                                canProceedFromProofOfIncome = false;
                            }
                            this.setState({
                                incomeDocuments: incomeDocuments,
                                canProceedFromProofOfIncome: canProceedFromProofOfIncome
                            });
                        })
                    }
                </Col>
            </Fragment>
            <CreateObjectRowWithLabelComponent>
                {
                    documentType
                    && <Fragment>
                        {
                            documentObject.file !== undefined
                                ?
                                <Fragment>
                                    {S3DocumentUploadComponent.renderImageDisplay(documentObject.file)}
                                </Fragment>
                                : <S3DocumentUploadComponent
                                    documentType={LimitIncreaseDocumentType.PROOF_OF_INCOME}
                                    showButton={false}
                                    className={"mobile"}
                                    onFileSelected={file => {
                                        if (file !== null) {
                                            let incomeDocuments = [...this.state.incomeDocuments];
                                            incomeDocuments[documentIndex].file = file;
                                            this.setState({
                                                incomeDocuments: incomeDocuments,
                                                canProceedFromProofOfIncome: true
                                            });
                                        }
                                    }}
                                />
                        }
                    </Fragment>
                }
            </CreateObjectRowWithLabelComponent>
            <hr/>
        </Fragment>
    }

    //STEP 3
    renderProofOfResidency() {
        return <Fragment>
            <ViewHeaderComponent>Proof of Address</ViewHeaderComponent>
            {
                this.state.addressDocuments.length === 0 && <Fragment>
                    <Fragment>No address documents
                        added</Fragment>
                    <br/>
                    <br/>
                </Fragment>
            }
            {
                this.state.addressDocuments.map((singleDocument, index) => {
                    return this.renderSingleAddressDocument(index);
                })
            }
            {this.state.addressDocuments.length < LimitIncreaseConfig.MAX_ADDRESS_DOCUMENTS && this.renderAddressDocumentAddSection()}

            <hr/>
            {this.renderModalFooterBackButton()}
            {'   '}
            {this.state.canProceedFromProofOfResidency &&
            <Fragment>
                {this.renderModalFooterNextButton()}
            </Fragment>
            }

        </Fragment>
    }

    renderAddressDocumentAddSection() {
        return this.renderAddButton(
            () => {
                let addressDocuments = [...this.state.addressDocuments];
                addressDocuments.push({});
                this.setState({
                    addressDocuments: addressDocuments
                })
            }, "Proof Of Residency");
    }

    renderSingleAddressDocument(documentIndex) {
        let documentObject = this.state.addressDocuments[documentIndex];
        let documentType = documentObject.documentType;
        return <Fragment key={documentIndex}>
            <Fragment>
                <Col md={12} style={{display: "flex", padding: "0px"}}>
                    <div style={{flex: "1"}}>
                        <DropdownComponent
                            options={this.state.proofOfAddressTypes}
                            optionValue={"name"}
                            optionText={"displayValue"}
                            placeholder={"Document Type"}
                            disableSearch={true}
                            onChange={(selectedOption) => {

                                let addressDocuments = [...this.state.addressDocuments];
                                if (selectedOption === null)
                                    addressDocuments[documentIndex].documentType = null;
                                else
                                    addressDocuments[documentIndex].documentType = selectedOption.name;

                                this.setState({addressDocuments: addressDocuments})
                            }}
                            value={documentObject.documentType}
                        />
                    </div>
                    {
                        this.renderImageCloseButton(() => {
                            let canProceedFromProofOfResidency = true;
                            let addressDocuments = [...this.state.addressDocuments];
                            addressDocuments.splice(documentIndex, 1);
                            if (addressDocuments.length === 0) {
                                canProceedFromProofOfResidency = false;
                            }
                            this.setState({
                                addressDocuments: addressDocuments,
                                canProceedFromProofOfResidency: canProceedFromProofOfResidency
                            });
                        })
                    }
                </Col>
            </Fragment>
            <CreateObjectRowWithLabelComponent>
                {
                    documentType && <Fragment>
                        {
                            documentObject.file !== undefined
                                ? S3DocumentUploadComponent.renderImageDisplay(documentObject.file)
                                : <S3DocumentUploadComponent
                                    documentType={LimitIncreaseDocumentType.PROOF_OF_ADDRESS}
                                    showButton={false}
                                    className={"mobile"}
                                    onFileSelected={file => {

                                        if (file !== null) {
                                            let addressDocuments = [...this.state.addressDocuments];
                                            addressDocuments[documentIndex].file = file;
                                            this.setState({
                                                addressDocuments: addressDocuments,
                                                canProceedFromProofOfResidency: true
                                            });
                                        }

                                    }}
                                />
                        }
                    </Fragment>
                }
            </CreateObjectRowWithLabelComponent>
        </Fragment>
    }

    //STEP 4
    renderSummary() {
        return <Fragment>
            <Fragment>
                <h4>Summary</h4>

                <hr/>

                <ViewHeaderComponent>Source of Income</ViewHeaderComponent>
                <Fragment>
                    {this.state.incomeValue.displayValue}
                </Fragment>
            </Fragment>

            <hr/>

            <ViewHeaderComponent>Proof of Income</ViewHeaderComponent>
            {this.state.incomeDocuments.map((image, key) => {
                return <Fragment key={key}>
                    {this.state.proofOfIncomeTypes.map((type, key) => {
                        return <Fragment key={key}>
                            {type.name === image.documentType && type.displayValue}
                        </Fragment>
                    })}
                    <br/>
                    <CreateObjectRowWithLabelComponent>
                        {S3DocumentUploadComponent.renderImageDisplay(image.file)}
                    </CreateObjectRowWithLabelComponent>
                </Fragment>
            })}

            <hr/>

            <ViewHeaderComponent>Proof of Residency</ViewHeaderComponent>
            {this.state.addressDocuments.map((image, key) => {
                return <Fragment key={key}>
                    {this.state.proofOfAddressTypes.map((type, key) => {
                        return <Fragment key={key}>
                            {type.name === image.documentType && type.displayValue}
                        </Fragment>
                    })}
                    <br/>
                    <CreateObjectRowWithLabelComponent>
                        {S3DocumentUploadComponent.renderImageDisplay(image.file)}
                    </CreateObjectRowWithLabelComponent>
                </Fragment>
            })}

            <hr/>
            {this.renderModalFooterBackButton()}
            {'   '}
            {this.renderModalFooterNextButton()}
        </Fragment>
    }

    //Buttons
    renderAddButton(onClickEvent, buttonText) {
        return <SFXButtonComponent className={"btn btn-primary"} onClick={onClickEvent}>
            Add {buttonText}
        </SFXButtonComponent>
    }

    renderImageCloseButton(onClickEvent) {
        return <SFXButtonComponent
            type='button' size="md" className={'btn btn-danger pull-left'}
            style={{display: "inline"}}
            onClick={onClickEvent}>
            <i className="fa fa-times"/>
        </SFXButtonComponent>
    }

    renderModalFooterBackButton() {
        return <Fragment>
            {this.state.currentStep !== SOURCE_OF_INCOME ?
                <SFXButtonComponent onClick={() => this.backStep(this.state.currentStep, this.state.currentStepIndex)}>
                    Back
                </SFXButtonComponent>
                :
                <SFXButtonComponent onClick={this.props.btnBackClick}>
                    Cancel
                </SFXButtonComponent>
            }
        </Fragment>
    }

    renderModalFooterNextButton() {
        return <Fragment>
            {this.state.currentStep === SUMMARY ?
                <Fragment>
                    {this.renderSubmitButton()}
                </Fragment>
                :
                <SFXButtonComponent onClick={() => this.nextStep(this.state.currentStep, this.state.currentStepIndex)}
                                    className={"btn btn-primary"}>
                    Next
                </SFXButtonComponent>
            }
        </Fragment>
    }

    renderSubmitButton() {
        return <Fragment>
            {this.state.submitting ?
                <SFXButtonComponent className="btn btn-primary"
                                    disabled={true}>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </SFXButtonComponent>
                :
                <SFXButtonComponent onClick={this.onSubmitClick.bind(this)} className={"btn btn-primary"}
                                    disabled={this.state.submitting}>
                    Submit
                </SFXButtonComponent>
            }
        </Fragment>
    }
}